import { useStores } from "stores";
import { observer } from "mobx-react-lite";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { useNavigate } from "react-router-dom";
import { Flex, Typography } from "antd";
import { routes } from "constants/routes";

export const BidsPageWithBalance = observer(() => {
  const { bidsWithBalance } = useStores();
  const navigate = useNavigate();

  return (
    <Flex vertical gap="large">
      <Typography.Title className="margin-none">Заявки с балансом</Typography.Title>
      <CommonTable
        store={bidsWithBalance}
        updateWithInterval
        columns={getColumns(bidsWithBalance)}
        onRow={(record) => ({
          onClick: (e) => {
            navigate(`/${routes.bids}/${record.id}`);
          },
          className: "cursor-pointer",
        })}
        whiteBox
        widgets={{
          search: true,
          date: false,
        }}
      />
    </Flex>
  );
});
